import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../server/graphql/__generated.types';

const defaultOptions = {} as const;
export type CreateAudioAccessTokenMutationVariables = Types.Exact<{
  inputs: Types.CreateAudioAccessTokenInputs;
}>;

export type CreateAudioAccessTokenMutation = {
  __typename?: 'Mutation';
  createAudioAccessToken: {
    __typename?: 'CreateAudioAccessTokenMutationResponse';
    code: string;
    success: boolean;
    message: string;
  };
};

export const CreateAudioAccessTokenDocument = gql`
  mutation CreateAudioAccessToken($inputs: CreateAudioAccessTokenInputs!) {
    createAudioAccessToken(inputs: $inputs) {
      code
      success
      message
    }
  }
`;
export type CreateAudioAccessTokenMutationFn = Apollo.MutationFunction<
  CreateAudioAccessTokenMutation,
  CreateAudioAccessTokenMutationVariables
>;

/**
 * __useCreateAudioAccessTokenMutation__
 *
 * To run a mutation, you first call `useCreateAudioAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudioAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudioAccessTokenMutation, { data, loading, error }] = useCreateAudioAccessTokenMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateAudioAccessTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAudioAccessTokenMutation,
    CreateAudioAccessTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAudioAccessTokenMutation,
    CreateAudioAccessTokenMutationVariables
  >(CreateAudioAccessTokenDocument, options);
}
export type CreateAudioAccessTokenMutationHookResult = ReturnType<
  typeof useCreateAudioAccessTokenMutation
>;
export type CreateAudioAccessTokenMutationResult =
  Apollo.MutationResult<CreateAudioAccessTokenMutation>;
export type CreateAudioAccessTokenMutationOptions = Apollo.BaseMutationOptions<
  CreateAudioAccessTokenMutation,
  CreateAudioAccessTokenMutationVariables
>;
